<div class='imbd-box'>
  <div nz-row>
  </div><br/>
  <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" [(nzSelectedIndex)]="index"
    class="imprcs002-tab-box">
    <nz-tab [nzTitle]="'ProxyAddsingle'|translate">
      <ng-template nz-tab>
        <app-AddProxy-Single [index]="index" *ngIf="index===0"></app-AddProxy-Single>
      </ng-template>
    </nz-tab>

    <nz-tab [nzTitle]="'ProxyAddmultiple'|translate">
      <ng-template nz-tab>
        <app-AddProxy-Multiple [index]="index" *ngIf="index===1"></app-AddProxy-Multiple>
      </ng-template>
    </nz-tab>

    <nz-tab [nzTitle]="'ChangeAgentSettings'|translate">
      <ng-template nz-tab>
        <app-AddProxy-Change [index]="index" *ngIf="index===2"></app-AddProxy-Change>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
